document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[js-main-product]').forEach(initMainProduct);
});

function initMainProduct(section) {
  const options = section.querySelectorAll('[js-variant-option]');
  const priceEl = section.querySelector('[js-variant-price]');
  const variantInput = section.querySelector('[js-variant-id]');
  const form = section.querySelector('form.main-product__form');
  const atcBtn = section.querySelector('[js-main-product-atc]');
  const atcText = section.querySelector('[js-atc-text]');
  const notifyBtn = section.querySelector('[js-main-product-notify]');
  const express = section.querySelector('[js-express-checkout]');
  const sticky = section.querySelector('[js-sticky-atc]');
  const stickyBtn = section.querySelector('[js-sticky-atc-btn]');
  const stickyPrice = section.querySelector('[js-sticky-price]');
  const defaultText = atcText ? atcText.innerHTML : '';
  const soldOutText = window.variantStrings ? window.variantStrings.soldOut : 'Sold out';

  options.forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();

      options.forEach(item => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-checked', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-checked', 'true');

      const available = option.getAttribute('data-variant-available') === 'true';
      const price = option.getAttribute('data-variant-price');

      if (priceEl) priceEl.innerHTML = price;
      if (stickyPrice) stickyPrice.innerHTML = price;

      if (variantInput) {
        variantInput.value = option.getAttribute('data-variant-id');
        // The express checkout buttons read the variant from this input.
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (atcBtn) {
        atcBtn.disabled = !available;
        if (atcText) atcText.innerHTML = available ? defaultText : soldOutText;
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.innerHTML = available ? defaultText : soldOutText;
      }

      // Back-in-stock button (reads the variant from the form's id input).
      if (notifyBtn) notifyBtn.hidden = available;
      if (express) express.hidden = !available;

      // A message about the previous variant's add no longer applies.
      section.querySelectorAll('.atc-feedback').forEach(el => el.remove());
    });
  });

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const variantId = variantInput ? Number(variantInput.value) : -1;
      if (variantId === -1 || atcBtn.disabled) return;

      // The feedback goes by whichever button was pressed: the sticky bar's
      // when the page's own button is scrolled out of view.
      const button = stickyBtn && e.submitter === stickyBtn ? stickyBtn : atcBtn;

      // atc.js: checks the response, shows the outcome by the button, updates the count.
      if (window.themeCart) {
        window.themeCart.add(variantId, 1, button);
      } else {
        form.submit();
      }
    });
  }

  // Sticky bar: shown once the page's own add-to-cart button has scrolled up
  // past the top of the screen, hidden again when it comes back. CSS keeps the
  // bar to phones. Checked on scroll rather than with an IntersectionObserver,
  // which misses a jump straight past the button (restored scroll position,
  // anchor links).
  if (sticky && atcBtn) {
    let queued = false;
    const update = () => {
      queued = false;
      const passed = atcBtn.getBoundingClientRect().bottom < 0;
      if (passed === !sticky.hidden) return;
      sticky.hidden = !passed;
      document.body.classList.toggle('has-sticky-atc', passed);
      if (!passed) sticky.querySelectorAll('.atc-feedback').forEach(el => el.remove());
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }
}
